import {TablePagination} from "@mui/material";


interface PropsType {
    totalItems: number,
    page: number,
    pageSize: number,
    handleChangePage: (number) => void,
    handleChangePageSize: (number) => void,
}

const CordwoodListPagination = ({page, pageSize, totalItems, handleChangePage, handleChangePageSize}: PropsType) => {
    return (totalItems ?
            <TablePagination width="100%" component="div" rowsPerPageOptions={[5, 10, 15, 25, 50, 200]} colSpan={5} count={totalItems} rowsPerPage={pageSize} page={page} onPageChange={(_, page) => {
                    handleChangePage(page)
                }} onRowsPerPageChange={(e) => {
                    handleChangePageSize(Number(e.target.value))
                }} slotProps={{ select: {
                    inputProps: {
                        'aria-label': 'rows per page',
                    },
                    native: true,
                } }}/>
            :
            <></>
    )
}
export default CordwoodListPagination;
